import { detection } from '@robovision/rvai-utils'


export enum Extensions {
  Bmp = '.bmp',
  Bz2 = '.bz2',
  Dcm = '.dcm',
  Dicom = '.dicom',
  Gif = '.gif',
  Gz = '.gz',
  H5 = '.h5',
  Ico = '.ico',
  Jpeg = '.jpeg',
  Jpg = '.jpg',
  Json = '.json',
  Nii = '.nii',
  Png = '.png',
  Record = '.record',
  Tar = '.tar',
  TarBz2 = '.tar.bz2',
  TarGz = '.tar.gz',
  TarXz = '.tar.xz',
  Tbz2 = '.tbz2',
  Tgz = '.tgz',
  Tif = '.tif',
  Tiff = '.tiff',
  Txz = '.txz',
  Xz = '.xz',
  Zip = '.zip'
}

export const AlgorithmExtensions = [
  Extensions.Tgz,
  Extensions.TarGz,
].sort()

export const ImageExtensions = [
  Extensions.Bmp,
  Extensions.Gif,
  Extensions.Jpeg,
  Extensions.Jpg,
  Extensions.Png,
  Extensions.Tif,
  Extensions.Tiff,
].sort()

const BasePackageExtensions = [
  Extensions.Tar,
  Extensions.TarBz2,
  Extensions.TarGz,
  Extensions.TarXz,
  Extensions.Tbz2,
  Extensions.Tgz,
  Extensions.Txz,
  Extensions.Zip,
].sort()

// mac os chromium doesn't support double file extension, it's a bug https://bugs.chromium.org/p/chromium/issues/detail?id=521781
const PackageExtensionsMac = [
  Extensions.Bz2,
  Extensions.Gz,
  Extensions.Xz,
].sort()

export const PackageExtensions = [
  ...BasePackageExtensions,
  ...(detection.isMac ? PackageExtensionsMac : []),
].sort()

export const ProjectSampleExtensions = [
  ...ImageExtensions,
  ...PackageExtensions,
  Extensions.Record,
].sort()

export const MultiviewProjectSampleExtensions = [
  ...PackageExtensions,
  Extensions.Record,
].sort()
